/* eslint-disable */
// assets
import {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconWallet,
    IconArrowBigUpLines,
    IconDeviceMobile,
    IconHandFinger,
    IconArrowsTransferDown,
    IconQrcode,
    IconCreditCard,
    IconFingerprint,
    IconDeviceMobileMessage,
    IconMoneybag,
    IconCircleNumber2,
    IconBuildingBank
} from '@tabler/icons';

// constant
const icons = {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconWallet,
    IconArrowBigUpLines,
    IconDeviceMobile,
    IconHandFinger,
    IconArrowsTransferDown,
    IconQrcode,
    IconCreditCard,
    IconFingerprint,
    IconDeviceMobileMessage,
    IconMoneybag,
    IconCircleNumber2,
    IconBuildingBank
};

// Robust check for boolean/truthy status in localStorage
const isTruthy = (val) => {
    if (val === true || val === 1) return true;
    if (typeof val === 'string') {
        const lower = val.trim().toLowerCase();
        return lower === 'true' || lower === '1' || lower === 'yes';
    }
    return false;
};

// ==============================|| BANKING SERVICES MENU ITEMS ||============================== //

export const getBankingServices = () => {
    const mobileBankingStatus = localStorage.getItem('mobileBanking');
    const rmemployee = localStorage.getItem('rmemployee') === 'true';

    const email = (localStorage.getItem('email_id') || '').trim().toLowerCase();
    const allowedDmtBetaEmails = ['merindixon@acemoney.in', 'sruthys240@gmail.com', 'adarv@gmail.com', 'adharvm26@gmail.com'];
    const checkAgentEmail = allowedDmtBetaEmails.includes(email);
    const allowedDmt3Emails = ['sruthys240@gmail.com'];
    const showDmt3 = allowedDmt3Emails.includes(email);

    const fingpayAepsStatus = localStorage.getItem('fingpay_aeps_status');
    const finoAepsStatus = localStorage.getItem('fino_aeps_status');
    const airtelAepsStatus = localStorage.getItem('airtel_aeps_status');

    return {
        id: 'newUtilities',
        title: 'Banking Services',
        type: 'collapse',
        icon: icons.IconBuildingBank,
        children: [
            {
                id: 'icons2',
                title: 'Domestic Money Transfer',
                type: 'collapse',
                icon: icons.IconArrowsTransferDown,
                children: [
                    {
                        id: 'dmtFino',
                        title: 'DMT 1',
                        type: 'item',
                        url: 'dmt/dmtTable',
                        breadcrumbs: false,
                        icon: icons.IconMoneybag
                    },
                    {
                        id: 'dmtAirtel',
                        title: 'DMT 2',
                        type: 'item',
                        url: 'dmt3/dmt-customerlist',
                        breadcrumbs: false,
                        icon: icons.IconMoneybag,
                        isNew: true
                    },
                    showDmt3 && {
                        id: 'dmtesaf',
                        title: 'DMT 3',
                        type: 'item',
                        url: 'dmt4/dmt-customerlist',
                        breadcrumbs: false,
                        icon: icons.IconMoneybag,
                        isNew: true
                    }
                ].filter(Boolean)
            },
            checkAgentEmail && {
                id: 'icons2-dmt',
                title: 'Domestic Money Transfer(Beta)',
                type: 'collapse',
                icon: icons.IconArrowsTransferDown,
                children: [
                    {
                        id: 'dmtFino1',
                        title: 'DMT 1',
                        type: 'item',
                        url: 'moneyTransfer1/viewCustomers',
                        breadcrumbs: false,
                        icon: icons.IconMoneybag
                    },
                    {
                        id: 'dmtIserVue2',
                        title: 'DMT 2',
                        type: 'item',
                        url: 'moneyTransfer2/viewCustomers',
                        breadcrumbs: false,
                        icon: icons.IconMoneybag
                    },
                    {
                        id: 'dmtairtel3',
                        title: 'DMT 3',
                        type: 'item',
                        url: 'moneyTransfer3/viewCustomers',
                        breadcrumbs: false,
                        icon: icons.IconMoneybag
                    }
                ].filter(Boolean)
            },
            !rmemployee && {
                id: 'matm',
                title: 'MATM',
                type: 'collapse',
                icon: icons.IconDeviceMobile,
                children: [
                    {
                        id: 'matm4',
                        title: 'Multi-Purpose Onboarding',
                        type: 'item',
                        url: 'matm/iserveu-matm-registration',
                        caption: 'AEPS/MATM/POS',
                        breadcrumbs: false
                    }
                ]
            },
            // aeps fingpay
            !rmemployee &&
                isTruthy(fingpayAepsStatus) && {
                    id: 'icons9986',
                    title: 'AEPS 1',
                    type: 'item',
                    icon: icons.IconHandFinger,
                    url: 'aeps/aeps1',
                    breadcrumbs: false
                },
            // aeps fino
            !rmemployee &&
                isTruthy(finoAepsStatus) && {
                    url: 'aeps/aeps2',
                    id: 'AEPS2NEW',
                    title: 'AEPS 2',
                    type: 'item',
                    icon: icons.IconHandFinger,
                    breadcrumbs: false
                },
            // aeps airtel
            !rmemployee &&
                isTruthy(airtelAepsStatus) && {
                    id: 'icons9996',
                    url: 'aeps/aeps3',
                    title: 'AEPS 2',
                    type: 'item',
                    icon: icons.IconHandFinger,
                    breadcrumbs: false
                },
            checkAgentEmail && {
                id: 'icons9986-aeps',
                title: 'AEPS 1(Beta)',
                type: 'item',
                icon: icons.IconHandFinger,
                url: 'aeps1/aeps',
                breadcrumbs: false
            },
            checkAgentEmail && {
                id: 'icons9996-aeps',
                title: 'AEPS 2(Beta)',
                type: 'item',
                icon: icons.IconHandFinger,
                url: 'aeps2/aeps',
                breadcrumbs: false
            },
            {
                id: 'icons07',
                title: 'Aadhaar Pay',
                type: 'item',
                icon: icons.IconFingerprint,
                url: 'aadhaarpay/aadhaarpay',
                breadcrumbs: false
            },
            checkAgentEmail && {
                id: 'icons0722',
                title: 'Aadhaar Pay(Beta)',
                type: 'item',
                icon: icons.IconFingerprint,
                url: '/aeps1/aadhaarpay',
                breadcrumbs: false
            },
            {
                id: 'tabler-icons881',
                title: 'My QR',
                type: 'item',
                icon: icons.IconQrcode,
                url: 'qr/myqr',
                breadcrumbs: false
            },
            isTruthy(mobileBankingStatus) && {
                id: 'tabler-icons8821',
                title: 'Mobile Banking',
                type: 'item',
                icon: icons.IconDeviceMobileMessage,
                url: 'mobile-banking/mobilebanking-list',
                breadcrumbs: false
            }
        ].filter(Boolean)
    };
};

const Wallets = getBankingServices();

export default Wallets;
